import type { Article } from "./types";

export const whatsappWeddingInvitation: Article = {
  slug: "whatsapp-wedding-invitation",
  published: true,
  publishedAt: "2026-10-27",
  updatedAt: "2026-10-27",
  title: {
    ro: "Cum trimiți invitația de nuntă sau botez pe WhatsApp",
    en: "How to send your wedding or baptism invitation on WhatsApp",
  },
  summary: {
    ro: "Ghid pas cu pas pentru generarea link-urilor scurte personalizate și trimiterea invitației digitale pe WhatsApp cu pre-completare RSVP.",
    en: "Step-by-step guide to generating personalized short links and sending your digital invitation on WhatsApp with RSVP pre-fill.",
  },
  body: {
    ro: [
      { t: "h2", text: "De ce să trimiți invitația pe WhatsApp" },
      {
        t: "p",
        text: "Majoritatea invitaților deschid mesajele de pe telefon în câteva minute. Cu o invitație digitală Jubiel, le trimiți un singur link către pagina evenimentului, unde văd programul, locațiile pe hartă și formularul de confirmare a prezenței (RSVP).",
      },
      { t: "h2", text: "Link-uri scurte personalizate pentru fiecare familie" },
      {
        t: "p",
        text: "În tab-ul „Invitați” poți genera un link scurt dedicat fiecărei familii (de forma wedistar.com/e/cod). Când invitatul deschide link-ul, formularul RSVP are deja completate numele familiei și datele de contact.",
      },
      {
        t: "ul",
        items: [
          "Adaugă familia în lista de invitați sau importă lista din CSV.",
          "Apasă pe „Generează link scurt” în dreptul familiei.",
          "Copiază link-ul și trimite-l pe WhatsApp împreună cu un mesaj cald.",
        ],
      },
      { t: "h2", text: "Urmărirea accesărilor și a confirmărilor" },
      {
        t: "p",
        text: "În editorul evenimentului vezi în timp real de câte ori a fost deschis fiecare link scurt și cine a confirmat prezența, inclusiv opțiunile de meniu și cazare.",
      },
    ],
    en: [
      { t: "h2", text: "Why send your invitation on WhatsApp" },
      {
        t: "p",
        text: "Most guests open messages on their phone within minutes. With a Jubiel digital invitation, you send a single link to the event page where guests see the schedule, map locations and the attendance confirmation (RSVP) form.",
      },
      { t: "h2", text: "Personalized short links for each household" },
      {
        t: "p",
        text: "In the “Guests” tab you can generate a dedicated short link for each family (such as wedistar.com/e/code). When the guest opens the link, the RSVP form already has their family name and contact details pre-filled.",
      },
      {
        t: "ul",
        items: [
          "Add the household to your guest list or import your list from CSV.",
          "Click “Generate short link” next to the family.",
          "Copy the link and send it on WhatsApp along with a warm note.",
        ],
      },
      { t: "h2", text: "Tracking visits and confirmations" },
      {
        t: "p",
        text: "In the event editor you can see in real time how many times each short link was opened and who confirmed attendance, including meal and accommodation preferences.",
      },
    ],
  },
};
